import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f77427"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 0,
  style: {"color":"chocolate"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  style: {"color":"forestgreen"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 6,
  class: "btn_box"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("打款")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "审核备注", -1))
const _hoisted_13 = { style: {"padding-top":"15px","display":"flex","justify-content":"flex-end"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "打款备注", -1))
const _hoisted_19 = { style: {"padding-top":"15px","display":"flex","justify-content":"flex-end"} }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("不打款")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确认打款")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "司机提现管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "dashed",
          onClick: _ctx.resetSearch
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'head_img')
          ? (_openBlock(), _createBlock(_component_ImageView, {
              key: 0,
              "image-url": text
            }, null, 8, ["image-url"]))
          : _createCommentVNode("", true),
        (column.key === 'approve')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_real_name ? '#87d068' : '#ff7875'})
              }, "实名认证：" + _toDisplayString(record.vali_real_name ? '已认证' : '未认证'), 5),
              _hoisted_2,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_driver ? '#87d068' : '#ff7875'})
              }, "驾驶证认证：" + _toDisplayString(record.vali_driver ? '已认证' : '未认证'), 5),
              _hoisted_3,
              _createElementVNode("a", {
                style: _normalizeStyle({color: record.vali_vehicle ? '#87d068' : '#ff7875'})
              }, "行驶证/物流运输证认证：" + _toDisplayString(record.vali_vehicle ? '已认证' : '未认证'), 5)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'bank_name')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", null, "银行：" + _toDisplayString(text), 1),
              _createElementVNode("div", null, "支行：" + _toDisplayString(record.account_bank), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.getStatus(text)), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'audit_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              text
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", null, "审核人：" + _toDisplayString(record.auditor?.name), 1),
                    _createElementVNode("div", null, "审核时间：" + _toDisplayString(_ctx.dateFormat(text * 1000)), 1),
                    _createElementVNode("div", null, "审核备注：" + _toDisplayString(record.audit_remark), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'transfer_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              text
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", null, "打款人：" + _toDisplayString(record.transfer?.name), 1),
                    _createElementVNode("div", null, "打款时间：" + _toDisplayString(_ctx.dateFormat(text * 1000)), 1),
                    _createElementVNode("div", null, "打款备注：" + _toDisplayString(record.transfer_remark), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (record.status === 0)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    size: "small",
                    class: "btn",
                    onClick: ($event: any) => (_ctx.setVisible(record, true, 1)),
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (record.status === 1)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "small",
                    class: "btn",
                    onClick: ($event: any) => (_ctx.setVisible(record, true, 2)),
                    type: "primary",
                    danger: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
      title: "提现审核",
      footer: null,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setVisible(undefined, false)))
    }, {
      default: _withCtx(() => [
        (_ctx.type === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入审核备注",
                rows: 4
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_button, {
                  style: {"margin-right":"15px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVisible(undefined, false)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  style: {"margin-right":"15px"},
                  type: "primary",
                  danger: true,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAudit(false))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAudit(true))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.type === 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入打款备注",
                rows: 4
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_a_button, {
                  style: {"margin-right":"15px"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setVisible(undefined, false)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  style: {"margin-right":"15px"},
                  type: "primary",
                  danger: true,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.auditCashTransfer(false))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.auditCashTransfer(true))),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}